import { render, staticRenderFns } from "./ApplicantBulkMessage.vue?vue&type=template&id=602052fe"
import script from "./ApplicantBulkMessage.vue?vue&type=script&lang=js"
export * from "./ApplicantBulkMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports